<template>
  <div class="text-grey-600 text-xs" :class="classes">
    By continuing you are creating an account and accepting our
    <a class="extra-link text-grey-600 text-underline hover:text-grey-600" target="_blank" href="https://www.tagvenue.com/page/terms-venue">Terms and Conditions</a>,
    <a class="extra-link text-grey-600 text-underline hover:text-grey-600" target="_blank" href="https://www.tagvenue.com/page/privacy-policy">Privacy Policy</a> and
    <a class="extra-link text-grey-600 text-underline hover:text-grey-600" target="_blank" href="https://www.tagvenue.com/page/terms-venue#6-booking-cancellation-policy">Cancellation and Refund Policy</a>.
  </div>
</template>

<script>
export default {
  name: 'ConsentsInfo',
  props: {
    classes: {
      type: String,
      default: '',
    },
  },
};
</script>
